import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import { Divider, Rating } from "@mui/material";
import { toUpper } from "lodash";
import { useNavigate } from "react-router-dom";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const dummyTopics = [
  {
    id: 1,
    user: "",
    title: "The picture is not displaying properly",
    feedback: "The Yi Home Mobile app is unable to pair with the camera",
    isAdmin: false,
  },
  {
    id: 2,
    user: "",
    title: "Unable to display video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 3,
    user: "",
    title: "The images are not playing in my video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
];

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function TickMetricFirstResponse(props: any) {
  const { reportsTicketsData } = props;
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const navigate = useNavigate();

  const handleRedirectUncategorisedTickets = () => {
    // navigate("/tickets");
    const stateObj = {
      pageType: "mainReportPage",
    };
    navigate(`/view-uncategorized-ticket`, { state: stateObj });
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#2858D3" : "#2858D3",
    },
  }));

  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  // const getModifiedTime = (val: any) => {
  //   if (!val || !val.firstResponseData || val.firstResponseData.length === 0)
  //     return null;

  //   const data = val.firstResponseData[0];

  //   let timeData;
  //   if (data.firstResponseTimeInDays < 1) {
  //     timeData = (
  //       <Typography className="ticket-metric-respo-resolu-tile-num">
  //         {data.firstResponseTimeInHours < 1 ? (
  //           <>
  //             {data.firstResponseTimeInMinutes.toFixed(2)}&nbsp;
  //             <span>Minutes</span>
  //           </>
  //         ) : (
  //           <>
  //             {data.firstResponseTimeInHours.toFixed(2)}&nbsp;
  //             <span>Hours</span>
  //           </>
  //         )}
  //       </Typography>
  //     );
  //   } else {
  //     timeData = (
  //       <Typography className="ticket-metric-respo-resolu-tile-num">
  //         {data.firstResponseTimeInDays.toFixed(2)}&nbsp;
  //         <span>Days</span>
  //       </Typography>
  //     );
  //   }

  //   return timeData;
  // };

  const convertedTime = (val: any) => {
    if (!val || !val.firstResponseData || val.firstResponseData.length === 0)
      return null;
    const data = val.firstResponseData[0];
    const inputNumber = data?.firstResponseTimeInDays || 0;
    // Separate the integer part (days) and the decimal part
    const days = Math.floor(inputNumber);
    const decimalPart = inputNumber - days;
    const remHours = decimalPart * 24;
    const hours = Math.floor(remHours);
    const minutes = Math.floor((remHours - hours) * 60);

    const timedata = (
      <Typography className="ticket-metric-respo-resolu-tile-num">
        {/* {data.firstResponseTimeInDays.toFixed(2)}&nbsp; */}
        {days}&nbsp; <span>{days > 1 ? "Days" : "Day"}</span>&nbsp;
        {hours}&nbsp;<span>{hours > 1 ? "Hours" : "Hour"}</span>&nbsp;
        {minutes}&nbsp;<span>{minutes > 1 ? "Minutes" : "Minute"}</span>
      </Typography>
    );

    // console.log(`${days} day ${hours}hrs ${minutes}min`); // Outputs: 13 day 6hrs 31min

    return timedata;
  };

  return (
    <Grid
      sx={{ border: "1px solid #ccc", borderRadius: "8px", height: "100%" }}
    >
      <Typography className="repu-heading">
        <Typography sx={{ fontWeight: 700, fontSize: "13px" }}>
          FIRST RESPONSE TIME
          {/* <Avatar
            sx={{
              height: "35px",
              width: "35px",
              marginLeft: "5px",
              fontSize: "10px",
              background: "#2858D3",
              display: "inline-flex",
              border: "1px solid #FFF",
            }}
          >
            85
          </Avatar> */}
        </Typography>
        {/* <Typography
          sx={{
            color: "#2858D3",
            fontWeight: 700,
            fontSize: "13px",
            cursor: "pointer",
          }}
          component="div"
          onClick={() => handleRedirectUncategorisedTickets()}
        >
          VIEW TICKETS
        </Typography> */}
      </Typography>
      <div
        style={{
          // height: "200px",
          overflowY: "auto",
          // justifyContent: "center",
          // alignItems: "center",
          // display: "flex",
        }}
      >
        <Box>
          {/* {convertedTime(reportsTicketsData)} */}
          {convertedTime(reportsTicketsData) || (
            <Typography className="ticket-metric-respo-resolu-tile-num">
              0
            </Typography>
          )}
          <Divider />
          <Typography className="ticket-metric-respo-resolu-tile-details">
            Average time taken to respond to the first email sent by the
            customer
          </Typography>
        </Box>
      </div>
    </Grid>
  );
}
